import { render, staticRenderFns } from "./HealthMetricCard.vue?vue&type=template&id=31202e6f&scoped=true&"
import script from "./HealthMetricCard.vue?vue&type=script&lang=ts&"
export * from "./HealthMetricCard.vue?vue&type=script&lang=ts&"
import style0 from "./HealthMetricCard.vue?vue&type=style&index=0&id=31202e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31202e6f",
  null
  
)

export default component.exports